import { EyeOutlined } from '@ant-design/icons'
import { Modal, Tooltip } from 'antd'
import { useState } from 'react'
import styled from 'styled-components'

// import { StyledImg } from 'styles/styledGlobal'

// const StyledImgClose = styled(StyledImg)`
//   width: 32px !important;
//   height: 32px !important;
//   &:hover {
//     opacity: 0.85;
//   }
// `

const StyledContainer = styled.div`
  svg {
    width: 20px;
    height: 20px;
  }
  &.prevent-remove {
    .ant-btn[title='Remove file'] {
      display: none;
    }
    .ant-upload {
      opacity: 0.5;
      pointer-events: none;
    }
  }
  .ant-upload-list-item-actions {
    a[title='Preview file'] {
      pointer-events: initial !important;
      opacity: 1 !important;
    }
  }
  &.disabled .ant-upload-select {
    cursor: not-allowed;
    opacity: 0.7;
    .ant-upload {
      pointer-events: none;
    }
  }
`
const StyledModalPreviewPdf = styled(Modal)`
  height: 90vh;
  width: 1200px;
  .ant-modal-body {
    min-height: 85vh;
  }
  iframe {
    width: 100%;
    min-height: 85vh;
  }
  .ant-modal-close {
    right: -40px;
    top: -40px;
    color: white;
  }
`
const StyledImgContainer = styled.div`
  position: relative;
  max-width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 40px;
  }
  .ic-eye {
    display: none;
  }
  &:hover {
    .ic-eye {
      position: absolute;
      top: 50%;
      left: 50%;
      display: block;
      transform: translate(-50%, -50%);
    }
    .bg-layer {
      background: var(--color-background-loading-04);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
`
const StyledName = styled.div`
  color: var(--color-gray-111);
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export interface IPdfPreviewProps {
  src?: string
  previewTitle?: string
}
const PdfPreview = ({ src, previewTitle }: IPdfPreviewProps) => {
  const [previewOpen, setPreviewOpen] = useState(false)
  const handleCancel = () => setPreviewOpen(false)
  const handleOnClick = (e: any) => {
    setPreviewOpen(true)
  }

  return (
    <StyledContainer>
      <Tooltip title={previewTitle}>
        <StyledImgContainer onClick={handleOnClick}>
          <img src="/images/pg-pdf.png" alt=""></img>
          <StyledName>{previewTitle}</StyledName>
          <div className="bg-layer"></div>
          <EyeOutlined className="ic-eye" style={{ color: 'white' }} />
        </StyledImgContainer>
      </Tooltip>
      <StyledModalPreviewPdf
        closable
        open={previewOpen}
        title={previewTitle}
        footer={null}
        width="90vw"
        onCancel={handleCancel}>
        <iframe
          id="iframe-preview-pdf"
          title="preview-pdf"
          src={src}
          frameBorder={0}
          scrolling="auto"
        />
      </StyledModalPreviewPdf>
    </StyledContainer>
  )
}

export default PdfPreview
